import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "layout-px-spacing" };
const _hoisted_2 = { class: "row layout-top-spacing" };
const _hoisted_3 = { class: "col-xl-12 col-lg-12 col-sm-12 layout-spacing" };
const _hoisted_4 = { class: "panel br-6 shadow-sm" };
const _hoisted_5 = { class: "custom-panel-header d-flex justify-content-between align-items-center p-4" };
const _hoisted_6 = { class: "header-actions d-flex gap-2" };
const _hoisted_7 = { class: "p-4 pt-0" };
const _hoisted_8 = { class: "table-responsive" };
const _hoisted_9 = { class: "table table-hover align-middle" };
const _hoisted_10 = { class: "d-flex align-items-center" };
const _hoisted_11 = { class: "form-icon me-3" };
const _hoisted_12 = { class: "fw-bold" };
const _hoisted_13 = { class: "badge bg-light-secondary text-secondary border smaller text-uppercase" };
const _hoisted_14 = ["onClick"];
const _hoisted_15 = { class: "recipients-list" };
const _hoisted_16 = { class: "form-check form-switch custom-switch-v1" };
const _hoisted_17 = ["id", "onUpdate:modelValue", "onChange"];
const _hoisted_18 = ["for"];
const _hoisted_19 = { class: "text-center" };
const _hoisted_20 = { class: "d-flex justify-content-center gap-2" };
const _hoisted_21 = ["onClick"];
const _hoisted_22 = { key: 0 };
const _hoisted_23 = { key: 1 };
const _hoisted_24 = {
    colspan: "6",
    class: "text-center py-5"
};
const _hoisted_25 = { class: "empty-state" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _cache[3] || (_cache[3] = _createElementVNode("div", null, [
                            _createElementVNode("h4", { class: "m-0 fw-bold text-dark" }, "Gestion des Formulaires"),
                            _createElementVNode("p", { class: "text-muted small mb-0" }, "Créez et gérez vos formulaires personnalisables pour votre site web.")
                        ], -1)),
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("button", {
                                class: "btn btn-outline-secondary btn-sm",
                                onClick: _cache[0] || (_cache[0] =
                                    //@ts-ignore
                                    (...args) => (_ctx.fetchForms && _ctx.fetchForms(...args)))
                            }, [...(_cache[1] || (_cache[1] = [
                                    _createElementVNode("i", { class: "ri-refresh-line me-1" }, null, -1),
                                    _createTextVNode(" Actualiser ", -1)
                                ]))]),
                            _createVNode(_component_router_link, {
                                to: { name: 'VabeneFormEditorPage', params: { action: 'add' } },
                                class: "btn btn-primary btn-sm"
                            }, {
                                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                        _createElementVNode("i", { class: "ri-add-line me-1" }, null, -1),
                                        _createTextVNode(" Nouveau Formulaire ", -1)
                                    ]))]),
                                _: 1
                            })
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("table", _hoisted_9, [
                                _cache[11] || (_cache[11] = _createElementVNode("thead", { class: "bg-light" }, [
                                    _createElementVNode("tr", null, [
                                        _createElementVNode("th", null, "Nom du Formulaire"),
                                        _createElementVNode("th", null, "Type"),
                                        _createElementVNode("th", null, "Shortcode (Copier)"),
                                        _createElementVNode("th", null, "Destinataires"),
                                        _createElementVNode("th", null, "Statut"),
                                        _createElementVNode("th", { class: "text-center" }, "Actions")
                                    ])
                                ], -1)),
                                _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.forms, (form) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                            key: form.id,
                                            class: _normalizeClass({ 'opacity-50': !form.isActive })
                                        }, [
                                            _createElementVNode("td", null, [
                                                _createElementVNode("div", _hoisted_10, [
                                                    _createElementVNode("div", _hoisted_11, [
                                                        _createElementVNode("i", {
                                                            class: _normalizeClass(_ctx.getFormIcon(form.type))
                                                        }, null, 2)
                                                    ]),
                                                    _createElementVNode("span", _hoisted_12, _toDisplayString(form.name), 1)
                                                ])
                                            ]),
                                            _createElementVNode("td", null, [
                                                _createElementVNode("span", _hoisted_13, _toDisplayString(form.type), 1)
                                            ]),
                                            _createElementVNode("td", null, [
                                                _createElementVNode("div", {
                                                    class: "shortcode-copy d-flex align-items-center",
                                                    onClick: ($event) => (_ctx.copyShortcode(form.slug))
                                                }, [
                                                    _createElementVNode("code", null, "[form:" + _toDisplayString(form.slug) + "]", 1),
                                                    _cache[4] || (_cache[4] = _createElementVNode("i", { class: "ri-file-copy-line ms-2 text-primary cursor-pointer" }, null, -1))
                                                ], 8, _hoisted_14)
                                            ]),
                                            _createElementVNode("td", null, [
                                                _createElementVNode("div", _hoisted_15, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.settings?.recipient_emails, (email, idx) => {
                                                        return (_openBlock(), _createElementBlock("span", {
                                                            key: idx,
                                                            class: "badge bg-light-info text-dark me-1 smaller border"
                                                        }, _toDisplayString(email), 1));
                                                    }), 128))
                                                ])
                                            ]),
                                            _createElementVNode("td", null, [
                                                _createElementVNode("div", _hoisted_16, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        class: "form-check-input",
                                                        type: "checkbox",
                                                        id: 'switch-' + form.id,
                                                        "onUpdate:modelValue": ($event) => ((form.isActive) = $event),
                                                        onChange: ($event) => (_ctx.toggleFormStatus(form))
                                                    }, null, 40, _hoisted_17), [
                                                        [_vModelCheckbox, form.isActive]
                                                    ]),
                                                    _createElementVNode("label", {
                                                        class: "form-check-label small ms-1",
                                                        for: 'switch-' + form.id
                                                    }, _toDisplayString(form.isActive ? 'Actif' : 'Désactivé'), 9, _hoisted_18)
                                                ])
                                            ]),
                                            _createElementVNode("td", _hoisted_19, [
                                                _createElementVNode("div", _hoisted_20, [
                                                    _createVNode(_component_router_link, {
                                                        to: { name: 'VabeneFormEditorPage', params: { action: 'edit', id: form.id } },
                                                        class: "btn btn-sm btn-outline-primary action-btn",
                                                        title: "Modifier"
                                                    }, {
                                                        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                                                _createElementVNode("i", { class: "ri-edit-2-line" }, null, -1)
                                                            ]))]),
                                                        _: 1
                                                    }, 8, ["to"]),
                                                    _createElementVNode("button", {
                                                        class: "btn btn-sm btn-outline-danger action-btn",
                                                        title: "Supprimer",
                                                        onClick: ($event) => (_ctx.confirmDelete(form))
                                                    }, [...(_cache[6] || (_cache[6] = [
                                                            _createElementVNode("i", { class: "ri-delete-bin-line" }, null, -1)
                                                        ]))], 8, _hoisted_21)
                                                ])
                                            ])
                                        ], 2));
                                    }), 128)),
                                    (_ctx.loading)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [...(_cache[7] || (_cache[7] = [
                                                _createElementVNode("td", {
                                                    colspan: "6",
                                                    class: "text-center py-5"
                                                }, [
                                                    _createElementVNode("div", {
                                                        class: "spinner-border text-primary",
                                                        role: "status"
                                                    }, [
                                                        _createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
                                                    ])
                                                ], -1)
                                            ]))]))
                                        : _createCommentVNode("", true),
                                    (!_ctx.loading && _ctx.forms.length === 0)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
                                            _createElementVNode("td", _hoisted_24, [
                                                _createElementVNode("div", _hoisted_25, [
                                                    _cache[9] || (_cache[9] = _createElementVNode("i", { class: "ri-chat-new-line fs-1 text-muted d-block mb-2" }, null, -1)),
                                                    _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-muted mb-3" }, "Aucun formulaire trouvé.", -1)),
                                                    _createVNode(_component_router_link, {
                                                        to: { name: 'VabeneFormEditorPage', params: { action: 'add' } },
                                                        class: "btn btn-primary btn-sm"
                                                    }, {
                                                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                                                _createTextVNode(" Créer mon premier formulaire ", -1)
                                                            ]))]),
                                                        _: 1
                                                    })
                                                ])
                                            ])
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ])
                    ])
                ])
            ])
        ])
    ]));
}
